import { render, staticRenderFns } from "./LecturerStatisticsReportFilter.vue?vue&type=template&id=19376357&"
import script from "./LecturerStatisticsReportFilter.vue?vue&type=script&lang=js&"
export * from "./LecturerStatisticsReportFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports